/**
 * `Momentum.status` enum — legacy `momentum-edit.component.html:38-46`
 * (`<option value="1">Active</option>` … `<option value="9">Trashed</option>`)
 * and backend `STATUSES = (1, 2, 3, 9)` (`api.cryptopairscreener.com`'s
 * `app/momentum/store.py`, which 422s any other value). Kept as one shared
 * module so `MomentumEditPage`'s status `<select>` and `MomentumListPage`'s
 * status column can't silently drift apart (the list page previously only
 * distinguished `1` "Active" from everything-else "Inactive").
 */
export const STATUS_OPTIONS: { value: number; label: string }[] = [
  { value: 1, label: 'Active' },
  { value: 2, label: 'Paused' },
  { value: 3, label: 'Archived' },
  { value: 9, label: 'Trashed' },
]

export function momentumStatusLabel(status: number | null | undefined): string {
  return STATUS_OPTIONS.find((option) => option.value === status)?.label ?? 'Unknown'
}

/** Badge visual variant per status — success (active), warning (paused),
 * plain/default (archived), danger (trashed). Matches `.screener-badge(--*)`
 * in `src/styles.css`. */
export function momentumStatusBadgeVariant(status: number | null | undefined): '' | 'success' | 'warning' | 'danger' {
  switch (status) {
    case 1:
      return 'success'
    case 2:
      return 'warning'
    case 9:
      return 'danger'
    default:
      return ''
  }
}
